import { render, staticRenderFns } from "./SessionDetails.vue?vue&type=template&id=f10ad9c6"
import script from "./SessionDetails.vue?vue&type=script&lang=js"
export * from "./SessionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports